
import { i18nText } from '@/locales';

import {Component, Vue, Watch} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import LineChartComponent from "@/UI/components/finance/LineChartComponent.vue";
import PieChartComponent from "@/UI/components/finance/PieChartComponent.vue";
import Breadcrumb from "@/UI/components/finance/FinanceBreadcrumbLine.vue";
import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";
import CashboxAddForm from "@/form/finance/cashbox/CashboxAddForm";
import CashboxUpdateForm from "@/form/finance/cashbox/CashboxUpdateForm";
import CashboxTransferForm from "@/form/finance/cashbox/CashboxTransferForm";
import CashboxAddComponent from "@/UI/components/forms/finance/cashbox/CashboxAddComponent.vue";
import CashboxUpdateComponent from "@/UI/components/forms/finance/cashbox/CashboxUpdateComponent.vue";
import CashboxTransferComponent from "@/UI/components/forms/finance/cashbox/CashboxTransferComponent.vue";
import {CashboxTypesStore} from "@/store/modules/Finance/CashboxTypes";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {UserStore} from "@/store/modules/User";
import {ICashboxListItem} from "@/entity/finance/cashbox/cashbox.types";
import {message} from "ant-design-vue";
import {mixins} from "vue-class-component";
import {ProxyDataForm} from "@/UI/components/Helpers/ProxyDataForm";

import FinanceOperationsAddComponent
  from "@/UI/components/forms/finance/finance_operations/FinanceOperationsAddComponent.vue";
import FinanceOperationsAddForm from "@/form/finance/finance_operations/FinanceOperationsAddForm";
import {FinanceOperationsStore} from "@/store/modules/Finance/FinanceOperations";

import {CounterpartiesStore} from "@/store/modules/Counterparties";
import {ICounterpartiesListItem} from "@/entity/finance/counterparties/counterparties.types";

import {PaymentArticlesStore} from "@/store/modules/PaymentArticles";
import {IPaymentArticlesListItem} from "@/entity/finance/payment_articles/paymentArticles.types";

import {WorkersStore} from "@/store/modules/Workers";
import {IWorkersListItem} from "@/entity/workers/workers.types";

import {ClientsStore} from "@/store/modules/Clients";
import {IClientsListItem} from "@/entity/clients/clients.types";
import {getStudioId} from "@/UI/lib/state";
import moment from "moment";

@Component({
  components: {
    PageTitle,
    LineChartComponent,
    PieChartComponent,
    Breadcrumb,
    ModalWrapper,
    CashboxAddComponent,
    CashboxUpdateComponent,
    CashboxTransferComponent,
    FinanceOperationsAddComponent,
  },
})
export default class AccountsAndCashboxes extends mixins(ProxyDataForm) {
  form = new CashboxAddForm();
  updateForm = new CashboxUpdateForm();
  transferForm = new CashboxTransferForm();
  paymentForm = new FinanceOperationsAddForm();
  addCashboxModalVisible = false;
  updateCashboxModalVisible = false;
  transferModalVisible = false;
  addNewPaymentModalVisible = false;
  searchText = "";
  searchTimeOut: any;
  renderComponent: boolean = true
  pagination = {
    //showSizeChanger: true,
    pageSize: 20,
    total: 20,
  };

  async created() {
    //await CashboxStore.fetchAll({ limit: this.pagination.pageSize });
    //await UserStore.fetch();
  }

  async submit(): Promise<void> {
    if (await this.form.submit(CashboxStore.create)) {
      await this.getData();
      this.addCashboxModalVisible = false;
      this.form = new CashboxAddForm();
    }
  }

  async paymentAddSubmit(): Promise<void> {
    const form = this.paymentForm;
    if (form.sendingRequest) return;
    form.sendingRequest = true;
    try {
      const result = await FinanceOperationsStore.create(form.getFormData());
      if (result.status) {
        this.$message.success(result.response);
        this.addNewPaymentModalVisible = false;
        this.paymentForm = new FinanceOperationsAddForm();
        await this.getData();
      } else {
        this.$message.error(result.response);
      }
    } catch (error) {
      const response = error.response?.data;
      this.$message.error(response?.response || response?.message || error.message);
    } finally {
      form.sendingRequest = false;
    }
  }

  async updateSubmit(): Promise<void> {
    if (await this.updateForm.submit(CashboxStore.update)) {
      await this.getData();
      this.updateCashboxModalVisible = false;
      this.updateForm = new CashboxUpdateForm();
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    }
  }

  async transferSubmit(): Promise<void> {
    if (await this.transferForm.submit(CashboxStore.transfer)) {
      await this.getData();
      this.transferModalVisible = false;
      this.transferForm = new CashboxTransferForm();
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    }
  }

  get cashboxes() {
    return CashboxStore.items;
  }

  async handlePaymentAddModal(visible: boolean, id?: number): Promise<void> {
    this.paymentForm = new FinanceOperationsAddForm();
    if (visible && this.cashboxes) {
      if (!this.paymentForm.date) {
        this.paymentForm.date = moment().format('DD.MM.YYYY');
        this.paymentForm.time = moment().format('HH:mm');
      }
      this.paymentForm.setFormData(
          await this.paymentArticles(),
          await this.counterparties({value: ""}),
          this.cashboxes.data,
          id,
          undefined,
          getStudioId(this),
      );
    }

    this.addNewPaymentModalVisible = visible;
  }

  @Watch("$store.state.salon_id", { immediate: false })
  async getData(): Promise<void> {
    await CounterpartiesStore.fetchAll({filter: {salon_id: getStudioId(this)}})
    await PaymentArticlesStore.fetchAll({limit: -1, filter: {salon_id: getStudioId(this)}})
    await CashboxStore.fetchAll({limit: -1 ,filter: {salon_id: getStudioId(this)}})
    this.renderComponent = false
    this.$nextTick(() => {
      this.renderComponent = true;
    });
  }

  async handleCashboxAddModal(visible: boolean): Promise<void> {
    if (visible) {
      await this.fetchCashboxTypes();

      if (CashboxTypesStore.itemsLoaded) {
        this.form.setFormData(CashboxTypesStore.items);
      }
    }

    this.addCashboxModalVisible = visible;
  }

  handleCashboxUpdateModal(visible: boolean): void {
    this.updateCashboxModalVisible = visible;
  }

  handleCashboxTransferModal(visible: boolean): void {
    this.transferModalVisible = visible;
  }

  async fetchCashboxTypes(): Promise<void> {
    if (!CashboxTypesStore.itemsLoaded) {
      await CashboxTypesStore.fetchAll();
    }
  }

  showTransferModal(id: number, index: number): void {
    if (this.cashboxes) {
      let targetId: number | null;
      if (this.cashboxes.data[index + 1]) {
        targetId = this.cashboxes.data[index + 1].id;
      } else if (this.cashboxes.data[index - 1]) {
        targetId = this.cashboxes.data[index - 1].id;
      } else {
        targetId = id;
      }
      this.transferForm.setFormData(this.cashboxes.data, id, targetId);
    }

    this.transferModalVisible = true;
  }

  async showUpdateModal(record: ICashboxListItem): Promise<void> {
    await this.fetchCashboxTypes();

    if (CashboxTypesStore.itemsLoaded) {
      this.updateForm.setFormData(CashboxTypesStore.items, record);
    }
    this.updateCashboxModalVisible = true;
  }

  async deleteCashbox(id: number): Promise<void> {
    let response = await CashboxStore.delete(id);
    if (response && response.status) {
      message.success(i18nText("Касса успешно удалена"));
      await this.getData();
    } else {
      message.error(response.response);
    }
  }

  async searchTarget(data: Record<string, any>): Promise<void> {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(async () => {
      switch (data.type) {
        case 1:
          this.paymentForm.targets = await this.counterparties(data);
          break;
        case 2:
          this.paymentForm.targets = await this.clients(data);
          break;
        case 3:
          this.paymentForm.targets = await this.staff(data);
          break;
        default:
          break;
      }
    }, 600);
  }

  async paymentArticles(): Promise<IPaymentArticlesListItem[]> {
    if (!PaymentArticlesStore.paymentArticles) {
      await PaymentArticlesStore.fetchAll({limit: 10, filter: {salon_id: getStudioId(this)}});
    }

    if (PaymentArticlesStore.paymentArticles) {
      return PaymentArticlesStore.paymentArticles.data;
    } else {
      return [];
    }
  }

  async counterparties(data: Record<string, any>): Promise<ICounterpartiesListItem[]> {
    if (!CounterpartiesStore.counterparties || data.value) {
      await CounterpartiesStore.fetchAll({limit: 10, filter: {name: data.value, salon_id: getStudioId(this)}});
    }

    if (CounterpartiesStore.counterparties) {
      return CounterpartiesStore.counterparties.data;
    } else {
      return [];
    }
  }

  async clients(data: Record<string, any>): Promise<IClientsListItem[]> {
    if (!ClientsStore.clients || data.value) {
      await ClientsStore.fetchAll({limit: 10, filter: {name: data.value, salon_id: getStudioId(this)}});
    }

    if (ClientsStore.clients) {
      return ClientsStore.clients.data;
    } else {
      return [];
    }
  }

  async staff(data: Record<string, any>): Promise<IWorkersListItem[]> {
    if (!WorkersStore.workers || data.value) {
      await WorkersStore.fetchAll({limit: 10, filter: {name: data.value, salon_id: getStudioId(this)}});
    }

    if (WorkersStore.workers) {
      return WorkersStore.workers.data;
    } else {
      return [];
    }
  }
}
